<section class="flex h-100">
  <div
    *ngIf="paymentStatus == 'cancelled'"
    class="d-flex flex-column justify-content-center align-items-center h-100 w-100 gap-3"
  >
    <div class="d-flex row gap-3 text-center text-danger fs-5 fw-medium">
      <i class="pi pi-times-circle"></i>
      <span>You cancelled the payment.</span>
    </div>
    <p-button
      #btnRetry
      label="Retry"
      [rounded]="true"
      [loading]="btnRetry.loading"
      (onClick)="onPay(btnRetry)"
    />
  </div>
  <div
    *ngIf="paymentStatus == 'loading'"
    class="d-flex flex-column justify-content-center align-items-center h-100 w-100 gap-3"
  >
    <div class="d-flex row gap-3 text-center primary-text fs-5 fw-medium">
      <div>Please wait while we confirm your payment status.</div>
      <p-progressSpinner></p-progressSpinner>
    </div>
  </div>
  <div
    *ngIf="paymentStatus == 'failed'"
    class="d-flex flex-column justify-content-center align-items-center h-100 w-100 gap-3"
  >
    <div class="text-center text-danger fs-5 fw-medium">
      <i class="pi pi-exclamation-triangle"></i>
      <div>We are unable to confirm your payment status at this moment.</div>
    </div>
  </div>
  <div *ngIf="paymentStatus == 'success'" class="reg-success">
    <div class="row w-100">
      <div class="col"></div>
      <div class="col d-flex justify-content-center">
        <i class="pi pi-check"></i>
      </div>
      <div class="col d-flex align-items-center justify-content-end">
        <i class="pi pi-print" (click)="onPrintConfirmation()"></i>
        <i class="pi pi-download ms-2" (click)="onDownloadConfirmation()"></i>
      </div>
    </div>
    <div>
      Your entry to the 2025 Hill District Grandstand Show has been submitted.
    </div>
    <div>
      Your entry has been sent to your Ag Teacher/County Agent for approval. You
      will receive an email confirmation that your entry has been submitted and
      another when your entry has been approved by your Ag Teacher/County Agent.
    </div>
  </div>
  <div
    *ngIf="!paymentStatus"
    class="d-flex flex-column gap-2 summary-box h-100"
  >
    <div class="flex-grow-1">
      <div class="section-title">Entry Information</div>
      <div *ngFor="let department of selectedLivestocks">
        <div class="dept-name">{{ department[0] }}</div>
        <table class="s-table">
          <thead>
            <tr>
              <th
                *ngIf="department[0].toLowerCase() == 'ag mechanics'"
                scope="col"
                [style.width]="'35%'"
                data-label="Division"
              >
                Division
              </th>
              <th scope="col" data-label="Class">Class</th>
              <th
                *ngIf="department[0].toLowerCase() != 'ag mechanics'"
                scope="col"
                [style.width]="'35%'"
                data-label="Breed/Heifer"
              >
                Breed/Heifer
              </th>
              <th
                scope="col"
                class="text-end"
                [style.width]="'10%'"
                data-label="Price"
              >
                Price
              </th>
              <th
                scope="col"
                class="text-end"
                [style.width]="'10%'"
                data-label="Quantity"
              >
                Quantity
              </th>
              <th
                scope="col"
                class="text-end"
                [style.width]="'10%'"
                data-label="Total"
              >
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            @for (livestock of department[1]; track $index) {
            <tr scope="row">
              <td
                *ngIf="department[0].toLowerCase() == 'ag mechanics'"
                data-label="Division"
              >
                <div>
                  <span>
                    {{ livestock.division ?? "--" }}
                  </span>
                  <span *ngIf="livestock.projectDesc">
                    <i
                      class="pi pi-info-circle"
                      [pTooltip]="livestock.projectDesc"
                      tooltipPosition="top"
                    ></i>
                  </span>
                </div>
              </td>
              <td data-label="Class">
                <div class="class-name">
                  <div>{{ livestock.class }}</div>
                  <div
                    *ngIf="livestock.qualityCount"
                    class="show-hide-heifer-details"
                    (click)="livestock.expanded = !livestock.expanded"
                  >
                    {{ livestock.expanded ? "Hide Details" : "Show Details" }}
                  </div>
                </div>
              </td>
              <td
                *ngIf="department[0].toLowerCase() != 'ag mechanics'"
                data-label="Breed/Heifer"
              >
                {{ getSubClassName(livestock) }}
              </td>
              <td class="text-end" data-label="Price">
                {{ livestock.priceEach | currency : "USD" }}
              </td>
              <td class="text-end" data-label="Quantity">
                {{ livestock.count }}
              </td>
              <td class="text-end" data-label="Total">
                {{ livestock.totalPrice | currency : "USD" }}
              </td>
            </tr>
            <tr *ngIf="livestock.qualityCount" scope="row">
              <td
                *ngIf="
                  livestock.heiferId != undefined && livestock.heiferId != -1
                "
                class="heifer-details"
                colspan="5"
                [ngClass]="{
                  open: livestock.expanded,
                  close: !livestock.expanded
                }"
              >
                <div class="row">
                  <div
                    class="col-md-3 d-flex flex-column align-items-start mb-2 mb-md-0"
                  >
                    <span class="label">Heifer Registry #</span>
                    <span class="value">{{
                      livestock.qualityCount.heiferRegistryNo
                    }}</span>
                  </div>
                  <div
                    class="col-md-3 d-flex flex-column align-items-start mb-2 mb-md-0"
                  >
                    <span class="label">Date of Birth</span>
                    <span class="value">{{
                      livestock.qualityCount.dateOfBirth
                    }}</span>
                  </div>
                  <div
                    class="col-md-3 d-flex flex-column align-items-start mb-2 mb-md-0"
                  >
                    <span class="label">Breed</span>
                    <span class="value">{{ livestock.breed }}</span>
                  </div>
                  <div
                    class="col-md-3 d-flex flex-column align-items-start mb-2 mb-md-0"
                  >
                    <span class="label">Breed Name</span>
                    <span class="value">{{
                      livestock.qualityCount.breedName
                    }}</span>
                  </div>
                </div>
                <div class="row mt-2">
                  <div
                    class="col-md-3 d-flex flex-column align-items-start mb-2 mb-md-0"
                  >
                    <span class="label">Chapter</span>
                    <span class="value">{{
                      livestock.qualityCount.countyName
                    }}</span>
                  </div>
                  <div
                    class="col-md-3 d-flex flex-column align-items-start mb-2 mb-md-0"
                  >
                    <span class="label">Billing County</span>
                    <span class="value">{{
                      livestock.qualityCount.billingCounty
                    }}</span>
                  </div>
                  <div
                    class="col-md-9 d-flex flex-column align-items-start mb-2 mb-md-0"
                  >
                    <span class="label">Sire Name</span>
                    <span class="value">{{
                      livestock.qualityCount.sireName
                    }}</span>
                  </div>
                </div>
              </td>
              <td
                *ngIf="
                  livestock.heiferId == -1 || livestock.heiferId == undefined
                "
                class="heifer-details"
                colspan="5"
                [ngClass]="{
                  open: livestock.expanded,
                  close: !livestock.expanded
                }"
              >
                <div class="row">
                  <div
                    class="col-md d-flex flex-column align-items-start mb-2 mb-md-0"
                  >
                    <span class="label">Validation Tag Number</span>
                    <span class="value">{{
                      livestock.validationTagNumber
                    }}</span>
                  </div>
                  <div
                    class="col-md d-flex flex-column align-items-start mb-2 mb-md-0"
                  >
                    <span class="label">Registration Number</span>
                    <span class="value">{{
                      livestock.registrationNumber
                    }}</span>
                  </div>
                  <div
                    class="col-md d-flex flex-column align-items-start mb-2 mb-md-0"
                  >
                    <span class="label">Breed</span>
                    <span class="value">{{ livestock.breed }}</span>
                  </div>
                  <div
                    class="col-md d-flex flex-column align-items-start mb-2 mb-md-0"
                  >
                    <span class="label">Animal Name</span>
                    <span class="value">{{ livestock.animalName }}</span>
                  </div>
                  <div
                    class="col-md d-flex flex-column align-items-start mb-2 mb-md-0"
                  >
                    <span class="label">Birth Date</span>
                    <span class="value">{{
                      livestock.birthDate | date : "MM/dd/yyyy"
                    }}</span>
                  </div>
                </div>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="total text-end">
        Total : {{ registration.totalPayable | currency : "USD" }}
      </div>
    </div>
    <div *ngIf="!paymentStatus" class="row p-1">
      <div class="col-md d-flex justify-content-end gap-2">
        <p-button
          label="Back"
          [outlined]="true"
          [rounded]="true"
          (onClick)="onPreviousClick()"
        />
        <p-button
          #btnPay
          label="Pay"
          [rounded]="true"
          [loading]="btnPay.loading"
          (onClick)="onPay(btnPay)"
        />
      </div>
    </div>
  </div>
</section>
